export const normalUrl = "https://aikaidan.datang360.com/app-api";
export const batchUrl = "https://aikaidanpifa.datang360.com/app-api";
//配送版客户端
export const apkUrl =
  "https://aikaidanpeisong.oss-cn-shenzhen.aliyuncs.com/version/apk/爱开单配送版_v1.1.2.apk";
//通用版安卓
export const apkUrl2 = "https://aikaidan.oss-cn-shenzhen.aliyuncs.com/version/apk/com.techh1.aikaidan-0.0.1.apk"